<!-- this *ngIf will always return `true` -->
<div *ngIf="{ type: priceType$ | async } as priceTypeObservable" class="product-card__container">
  <a
    (click)="onProductClick(product, priceTypeObservable.type, $event)"
    [attr.mmTestId]="isProductList ? 'PRODUCT_CATALOG.PRODUCT_CARD' : null"
    [href]="baseProductPDPLink"
    [ngClass]="{
      'product-card--topProducts': !isProductList,
      'product-card--productList': isProductList,
      'no-bottom-padding': isDesktop && isProductAddToCartAllowed
    }"
    appDisableClickEvent
    class="product-card new-product-card-style"
    fxLayout="column"
    fxLayoutAlign=" start"
    test-target="product-card"
  >
    <div
      class="product-card__labels-container"
      *ngIf="
        !!product?.bestOffer?.promotion || (isBlackDealsEnabled && isBlackDealProduct) || !!product?.attributes?.series
      "
    >
      <app-product-promotion
        [fromProductCard]="true"
        [hasFixedHeight]="!isProductList"
        [isBlackDealsEnabled]="isBlackDealsEnabled && isBlackDealProduct"
        [isNewDesign]="true"
        [msrpDiscount]="product?.bestOffer?.referencePrice?.discountPercentage"
        [promotion]="!!product?.bestOffer?.promotion"
        [roundedLabels]="true"
        [serie]="!!product?.attributes?.series"
      >
      </app-product-promotion>
    </div>
    <div
      [ngClass]="{
        'product-card--topProducts__body-container': !isProductList,
        'product-card--productList__body-container': isProductList
      }"
      class="product-card__body-container"
      fxLayout="column"
      fxLayoutAlign="start"
    >
      <div class="product-card__sub-body-container" fxLayout="column" fxLayoutAlign="start">
        <div class="product-card__energy-label-container">
          <div
            [ngClass]="{
              'product-card__image-container--topProducts': !isProductList,
              'product-card__image-container--productList': isProductList
            }"
            class="product-card__image-container"
            test-target="product-card__image-container"
          >
            <!--        <div-->
            <!--          *ngIf="-->
            <!--            isMobile &&-->
            <!--            (!!product?.bestOffer?.promotion ||-->
            <!--              (isBlackDealsEnabled && isBlackDealProduct) ||-->
            <!--              !!product?.attributes?.series)-->
            <!--          "-->
            <!--          class="product-card__labels-container mobile__promotion-label"-->
            <!--        >-->
            <!--          <app-product-promotion-->
            <!--            [promotion]="!!product?.bestOffer?.promotion"-->
            <!--            [msrpDiscount]="product?.bestOffer?.referencePrice?.discountPercentage"-->
            <!--            [isBlackDealsEnabled]="isBlackDealsEnabled && isBlackDealProduct"-->
            <!--            [hasFixedHeight]="!isProductList"-->
            <!--            [fromProductCard]="true"-->
            <!--            [serie]="!!product?.attributes?.series"-->
            <!--            [roundedLabels]="true"-->
            <!--            [isNewDesign]="true"-->
            <!--          >-->
            <!--          </app-product-promotion>-->
            <!--        </div>-->
            <a [mmTestTarget]="'product-card-' + product?.mid">
              <img
                [alt]="product?.name"
                [appDefaultImage]="defaultProductImage"
                [appLazyLoadImage]="product?.image"
                [srcSet]="getSourceSet(product?.image)"
                class="product-card__image"
                loading="lazy"
              />
            </a>
            <app-search-product-energy-efficiency-new
              [energyEfficiencyImage]="product?.attributes?.energyEfficiencyImage"
              [energyConfig]="product?.attributes?.energy_config"
              [productId]="product?.id"
              [eecLabel]="product?.attributes?.eprel"
              class="product-card__energy-label"
            >
            </app-search-product-energy-efficiency-new>
          </div>
        </div>

        <app-variants-selector
          (bulletClicked)="onVariantSelected($event, product, priceTypeObservable.type)"
          [baseProductId]="product?.id"
          [baseProductImage]="product?.image"
          [carouselProductCard]="carouselProductCard"
          [isMobile]="isMobileOrTablet"
          [isSimilarProductRecommendation]="isSimilarProductRecommendation"
          [variantsSelectorHeightconfig]="shouldSaveSpaceForVariants"
          [variants]="product?.variant"
        ></app-variants-selector>
      </div>
      <div
        *ngIf="!showOnlyImageOnSimilarProductsCarousel"
        class="product-card__body"
        fxLayout="column"
        fxLayoutAlign="space-between start"
      >
        <div class="product-card__label__title">
          <p
            [lang]="country"
            [mmTestTarget]="'product-card-' + product?.name | kebabCase"
            [ngClass]="{ 'product-card__title--topProducts': !isProductList }"
            class="product-card__title"
          >
            {{ product?.name }}
          </p>

          <p *ngIf="isProductList && product?.attributes?.series" class="product-card__series">
            {{ 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.SERIES' | translate }}: {{ product?.attributes?.series }}
          </p>
        </div>

        <div class="product-card__attributes">
          <app-search-variants-price
            [product]="product"
            [saveTotalUnitsOrBasePriceSpace]="saveTotalUnitsOrBasePriceSpace"
          ></app-search-variants-price>
        </div>
      </div>
    </div>
  </a>
  <div
    *ngIf="
      (isDesktop && shouldSaveSpaceForAddToCart) ||
      (isDesktop &&
        !shouldSaveSpaceForAddToCart &&
        addToCartConfig?.shouldShowAddToCart &&
        isProductAddToCartAllowed) ||
      (addToCartConfig?.shouldShowAddToCart && isProductAddToCartAllowed && isMobileOrTablet)
    "
    class="plps__add-to-cart-container"
  >
    <ng-container *ngIf="addToCartConfig?.shouldShowAddToCart && isProductAddToCartAllowed">
      <p class="plps__add-to-cart-shipping-disclaimer">
        {{ 'CATALOG.CATALOG_PAGE.ADD_TO_CART.SHIPPING_DISCLAIMER' | translate }}
      </p>
      <div
        class="plps__add-to-cart-inner"
        fxLayout="column"
        fxLayout.mm-desktop="row nowrap"
        fxLayout.mm-mobile="row nowrap"
        fxLayout.mm-tablet="row nowrap"
        fxLayout.mm-tablet-landscape="row nowrap"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.mm-tablet-landscape="space-between"
      >
        <div class="plps__add-to-cart-wrapper" fxLayout="column">
          <div fxLayout="row">
            <ng-container *ngIf="!addToCartConfig?.shouldHideMOQ">
              <mm-quantity-picker
                #toggleButton
                (disabledIncreaseTriggered)="onDisabledIncrease()"
                (quantityChanged)="onQuantityChanged(product, $event)"
                (quantityPrettified)="onQuantityPrettified()"
                [amount]="quantity <= product?.bestOffer?.quantity ? quantity : product?.bestOffer?.quantity"
                [availableAmount]="product?.bestOffer?.quantity"
                [minAmount]="minAmount"
                [mmTestTarget]="isDesktop ? 'quantity-picker--desktop' : 'quantity-picker'"
                [ngClass]="{
                  stockavailablePicker: product?.bestOffer?.quantity > 0,
                  DESKTOP: isDesktop,
                  MOBILE: isMobileOrTablet,
                  'can-disable': quantity > 1
                }"
                [showLabels]="false"
              >
              </mm-quantity-picker>
              <app-plps-add-to-cart-quantity-check-tooltip
                (hideTooltip)="hideQtyNotEnoughAlert()"
                *ngIf="qtyTooltip"
                [currentOffer]="product?.bestOffer"
                [noOfOffers]="1"
              >
              </app-plps-add-to-cart-quantity-check-tooltip>
            </ng-container>
            <button
              (click)="onAddToCart($event, product)"
              [loading]="addToCartLoading"
              [mmTestTarget]="isDesktop ? 'add-to-cart-button' : 'add-to-cart-button-mobile'"
              [ngClass]="{
                'add-to-cart__plps__submit-active': addingToCart,
                'add-to-cart__plps__full-width': addToCartConfig?.shouldShowAddToCart && addToCartConfig?.shouldHideMOQ
              }"
              class="add-to-cart__plps mm-button--large"
              color="primary"
              fxFlex.mm-mobile="40"
              id="addToCartMobilePlps"
              mm-button
              title="{{ 'CATALOG.DETAILS_PAGE.OFFERS_BOX.ADD_TO_CART.PLACEHOLDER' | translate }}"
            >
              <mm-icon name="add-to-cart"></mm-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
